import { columnFromDefinition, GridColumnDefinition } from "@repo/ui";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

interface BackendGrid<T> {
	gridId: number;
	name: string;
	columns: GridColumnDefinition<T>[];
}

export function useGridColumns<T>(
	gridName: string,
	getGridColumnsFn: () => Promise<BackendGrid<T>>,
	callbacks?: Record<string, Function>,
	settings?: Record<string, any>,
) {
	const { data, isLoading, isError } = useQuery({
		queryKey: ["GridColumns", gridName],
		queryFn: () => getGridColumnsFn(),
	});

	const columns = useMemo(() => {
		if (!data?.columns) return [];
		return data.columns.map((col) => columnFromDefinition(col, { callbacks, settings }));
	}, [data, settings, callbacks]);

	return { columns, isLoading: isLoading && !isError };
}
